import React from "react";
import tsawLogo from "../../assets/TSAW-logo-edit.png"
const LoginHeader = () => {
  return (
    <div className="flex justify-between items-center">
      <div className="logo w-16 h-16">
        <img
          className="w-full h-full"
          style={{ objectFit: "contain" }}
          src={tsawLogo}
          alt="logo"
        />
      </div>
      <div className="utm text-right">
        <h1 className="text-tblu text-5xl">UTM</h1>
        <h2>Unpiloted Traffic Management</h2>
      </div>
    </div>
  );
};

export default LoginHeader;
